define('GameDayCore/GDModel/ValueObjects/Hits/HitsFile',['require','exports','module','../ValueObjectFactory','extant/extant','ensureArray/ensureArray','./Hit'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        exists = require("extant/extant"),
        ensureArray = require('ensureArray/ensureArray');

	VO.create(Hits);

	function Hits($data) {
		var vo = VO.ensureVO(this, Hits),
			data = $data;

		vo.hits = parseHits(data);
	}

	function parseHits(data) {
		var home = [],
			away = [],
			away_hits = [],
			away_outs = [],
			home_hits = [],
			home_outs = [],
			hit,
			Hit = require('./Hit');


		if (!exists(data.hip)) {
			return;	
		} 

		var hitVOs = ensureArray(data.hip);
		for (var i = 0, len = hitVOs.length; i < len; i++) {
			hit = new Hit(hitVOs[i]);

			if (hit.team === "A") {
				home.push(hit);
				if (hit.type === "O") {
					away_outs.push(hit);
				} else if (hit.type === "H") {
					away_hits.push(hit);
				}

			} else if (hit.team === "H") {
				away.push(hit);
				if (hit.type === "O") {
					home_outs.push(hit);
				} else if (hit.type === "H") {
					home_hits.push(hit);
				}
			}
		}

		return {
			away : away,
			home : home,
			away_hits: away_hits,
			away_outs: away_outs,
			home_hits: home_hits,
			home_outs: home_outs
		}
	}

	return Hits;
});
